import React from 'react'

interface MenuProps {
  open: boolean
  onClose: () => void
  children: React.ReactNode
  /** Inline positioning for the menu panel (e.g. { top, right }). */
  style?: React.CSSProperties
}

/** Popover menu with a full-screen outside-click catcher. Caller positions the panel. */
const Menu: React.FC<MenuProps> = ({ open, onClose, children, style }) => {
  if (!open) return null
  return (
    <>
      <div className="menu-catcher" onClick={onClose} />
      <div className="menu" style={style} role="menu">
        {children}
      </div>
    </>
  )
}

interface MenuItemProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: React.ReactNode
  danger?: boolean
}

export const MenuItem: React.FC<MenuItemProps> = ({ icon, danger, className = '', children, ...rest }) => (
  <button className={`menu__item ${danger ? 'menu__item--danger' : ''} ${className}`.trim()} role="menuitem" {...rest}>
    {icon}
    {children}
  </button>
)

export default Menu
